import React from 'react';
import { buildShopUrl, getGclid, trackCTAClick } from '../utils/tracking';
const SHOP_URL = 'https://hunderunde.shop/products/futtertopping-magen-darm';
export function CtaBox() {
  const handleClick = () => {
    trackCTAClick('Jetzt unverbindlich ansehen', 'mid-article');
  };
  const href = buildShopUrl(SHOP_URL, getGclid());
  return <div className="bg-gradient-to-br from-[#fef4e6] to-[#fdebd0] border border-amber-lt rounded-[14px] px-5 sm:px-[30px] py-7 sm:py-[36px] my-[3em] text-center" data-id="element-38">
      <p className="font-sans text-[0.68rem] font-bold tracking-[0.15em] uppercase text-amber mb-3" data-id="element-39">
        Das Topping, das ich meine
      </p>
      <h3 className="font-serif text-[1.3rem] font-bold text-text mb-3 leading-[1.35]" data-id="element-40">
        Futtertopping Magen & Darm – gezielte Unterstützung der Darmflora für
        Hunde mit Juckreiz
      </h3>
      <p className="font-sans text-[0.9rem] text-text-mid max-w-[460px] mx-auto mb-6 leading-[1.65]" data-id="element-41">
        Juckreiz beginnt oft im Darm. Das Topping enthält 8 pflanzliche Zutaten,
        die das Darmmikrobiom stabilisieren – einfach täglich über das gewohnte
        Futter streuen.
      </p>
      <a href={href} onClick={handleClick} className="inline-block bg-amber hover:bg-amber-deep text-white font-sans font-bold text-[0.92rem] no-underline rounded-full px-8 py-[14px] tracking-[0.02em] shadow-[0_4px_18px_rgba(196,124,46,0.28)] transition-all duration-200 hover:-translate-y-[2px]" rel="sponsored" target="_blank" data-id="element-42">
        Jetzt unverbindlich ansehen →
      </a>
      <p className="font-sans text-[0.73rem] text-text-muted mt-[14px]" data-id="element-43">
        60 Tage Verträglichkeitsgarantie · Rein pflanzlich · Hergestellt in
        Deutschland
      </p>
      <div className="flex gap-[14px] justify-center flex-wrap mt-[14px]" data-id="element-44">
        <span className="font-sans text-[0.76rem] font-semibold text-text-mid" data-id="element-45">
          ✓ Kein Risiko
        </span>
        <span className="font-sans text-[0.76rem] font-semibold text-text-mid" data-id="element-46">
          ✓ Ohne Zusätze
        </span>
        <span className="font-sans text-[0.76rem] font-semibold text-text-mid" data-id="element-47">
          ✓ Für alle Futterarten geeignet
        </span>
      </div>
    </div>;
}